/**
 * Ruta de impresion y llave de S3 del PDF de un documento electronico.
 *
 * Las dos expresiones estaban repetidas (con variaciones) en cada lugar que genera
 * un PDF, y tienen que coincidir exactamente con lo que la lambda `AtvStatusChecker`
 * lee de S3 al armar el correo de facturacion electronica:
 *
 *     suscription_numero + "/pdfs/" + folderName + "/" + documentkey + ".pdf"
 *
 * Si el camino de emision y el de reenvio construyen llaves distintas, el correo sale
 * sin adjunto y no hay ningun error: la lambda resuelve el objeto faltante como
 * `"null"` y envia igual. Por eso vive en un solo lugar.
 */

export type PdfDocumentKind = "Invoice" | "Creditnote" | "Debitnote" | "BuyInvoice";

/**
 * Segmento de la ruta de impresion en `AppRouter`. No se deriva del `kind` porque
 * `buyInvoices` es camelCase y los demas son minusculas: derivarlo con
 * `${kind}s.toLowerCase()` genera `/user/buyinvoices/...`, que no existe.
 */
const PRINT_ROUTE_SEGMENT: Record<PdfDocumentKind, string> = {
    Invoice: "invoices",
    Creditnote: "creditnotes",
    Debitnote: "debitnotes",
    BuyInvoice: "buyInvoices",
};

/**
 * Ruta de la vista de impresion que se renderiza para producir el PDF.
 *
 * Sin `?guide=1`: la guia de envio no debe salir en el PDF que viaja adjunto al
 * correo de facturacion electronica.
 */
export const documentPrintPath = (kind: PdfDocumentKind, documentId: string): string =>
    `/user/${PRINT_ROUTE_SEGMENT[kind]}/print/${documentId}/0/1`;

/** Llave del PDF en el bucket `mavisoft-pdfs`, tal como la busca `AtvStatusChecker`. */
export const documentPdfS3Key = (
    kind: PdfDocumentKind,
    suscriptionNumero: string | number | null | undefined,
    documentKey: string,
): string => `${suscriptionNumero}/pdfs/${kind}/${documentKey}.pdf`;
